/**
 * /onboarding while self-signup is closed (LEGAL 29.10., Art. 13 DSGVO).
 * Static on purpose: no form, no fetch — nothing is collected here. The
 * wizard files stay in place for reopening (SELF_SIGNUP_OPEN in the backend).
 */
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { PublicLegalFooter } from "@/components/PublicLegalFooter";

export function SignupClosedPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle>QuizNudge</CardTitle>
          <CardDescription>Registrierung</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-center text-muted-foreground">
            Die Registrierung ist derzeit nur auf Einladung möglich. Kontakt:{" "}
            <a
              href="mailto:kontakt@99fingers.com"
              className="text-blue-600 hover:underline"
            >
              kontakt@99fingers.com
            </a>
          </p>
        </CardContent>
      </Card>
      <PublicLegalFooter />
    </div>
  );
}
